import { render } from "./FileIcon.vue?vue&type=template&id=f80b72ba"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FileIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f80b72ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f80b72ba', __exports__)) {
    api.reload('f80b72ba', __exports__)
  }
  
  module.hot.accept("./FileIcon.vue?vue&type=template&id=f80b72ba", () => {
    api.rerender('f80b72ba', render)
  })

}


export default __exports__